import React, { Suspense } from "react";
import { Spin } from "antd";
import { useParams } from "react-router-dom";
const PointGamesContainer = React.lazy(
  () => import("../../../../modules/Gamification/components/pointsGames")
);

const PointGamesPage = () => {
  const params = useParams<{ gamificationId: string }>();

  return (
    <Suspense fallback={<Spin />}>
      <PointGamesContainer gamificationId={params.gamificationId} />
    </Suspense>
  );
};

export default PointGamesPage;
